<!-- Features Start -->
<section class="iq-fancy-box-section">
  <img
    src="./assets/images/others/shape1.png"
    class="img-fluid shape-left"
    alt="QLOUD"
  />
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div
          class="text-center iq-title-box iq-title-default iq-title-box-2 wow fadeInUp"
          data-wow-duration="0.6s"
        >
          <div class="iq-title-icon"></div>
          <h2 class="iq-title">{{ "FEATURES_SYNC_HEADER" | translate }}</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 mb-lg-0 mb-5">
        <div
          class="iq-process iq-process-step-style-6 text-center wow fadeInUp"
          data-wow-duration="0.6s"
        >
          <div class="iq-process-step">
            <img
              class="iq-before-img img-fluid"
              src="../../assets/images/arrow/01.png"
              alt="arrow-img"
            />
            <div class="iq-step-content">
              <img class="hover-img img-fluid" width="100px" height="100px"  src="../../assets/images/se-icons/mysql-database.png" alt="cloud-sync"/>
            </div>
            <div class="iq-step-text-area">
              <h4 class="iq-step-title mt-3 mb-3">{{ "FEATURES_HEADER_1" | translate }}</h4>
              <span class="iq-step-desc">{{ "FEATURES_DESCRIPTION_1" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 mb-lg-0 mb-5">
        <div
          class="iq-process iq-process-step-style-6 text-center wow fadeInUp"
          data-wow-duration="0.6s"
        >
          <div class="iq-process-step">
            <img
              class="iq-before-img img-fluid"
              src="../../assets/images/arrow/01.png"
              alt="arrow-img"
            />
            <div class="iq-step-content">
              <img class="hover-img img-fluid" width="100" height="100" src="../../assets/images/se-icons/mariadb.png" alt="monitor"/>
            </div>
            <div class="iq-step-text-area">
              <h4 class="iq-step-title mt-3 mb-3">{{ "FEATURES_HEADER_2" | translate }}</h4>
              <span class="iq-step-desc">{{ "FEATURES_DESCRIPTION_2" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div
          class="iq-process iq-process-step-style-6 text-center wow fadeInUp"
          data-wow-duration="0.6s"
        >
          <div class="iq-process-step">
            <img class="iq-before-img img-fluid" src="" alt="arrow-img" />
            <div class="iq-step-content">
              <img class="hover-img img-fluid" width="100" height="100" src="../../assets/images/se-icons/cloud-it-department.png" alt="refresh"/>
            </div>
            <div class="iq-step-text-area">
              <h4 class="iq-step-title mt-3 mb-3">{{ "FEATURES_HEADER_3" | translate }}</h4>
              <span class="iq-step-desc">{{ "FEATURES_DESCRIPTION_3" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
